import * as React from 'react'

import { SHEET_INSET_CLASS } from '~/client/src/shared/components/OptionsList/surfaceInset'
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { DrillDownFilterShellProvider } from './DrillDownFilterShellContext'

export interface IDrillDownFilterDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  // Nested inside another vaul drawer: vaul keeps one global body slot, so
  // closing this one would restore <body> under its still-open parent.
  noBodyStyles?: boolean
}

export default function DrillDownFilterDrawer({
  open,
  onOpenChange,
  children,
  noBodyStyles,
}: IDrillDownFilterDrawerProps) {
  const shell = React.useMemo(
    () => ({ close: () => onOpenChange(false) }),
    [onOpenChange],
  )

  return (
    <DrillDownFilterShellProvider value={shell}>
      <Drawer
        open={open}
        onOpenChange={onOpenChange}
        noBodyStyles={noBodyStyles}
      >
        <DrawerContent
          className={`tw:h-[85vh] ${SHEET_INSET_CLASS}`}
          aria-describedby={undefined}
        >
          <DrawerTitle className="tw:sr-only">
            {Localization.translator.filters}
          </DrawerTitle>
          {children}
        </DrawerContent>
      </Drawer>
    </DrillDownFilterShellProvider>
  )
}
